import React from 'react';
import { CloneTooltipWrapper } from '@components/tooltip/Tooltip';
import { TabButton, TabsContainer } from './Tabs.style';

export interface TabsProps<TTab extends string> {
    tabs: readonly TTab[];
    selected?: TTab;
    onSelect?(tab: TTab): void;
    disabledTabs?: Partial<Record<TTab, string>>;
}

export function Tabs<TTab extends string>(props: TabsProps<TTab>) {
    const { tabs, selected, onSelect, disabledTabs } = props;

    const tabItems = tabs.map((t) => {
        const disabledReason = disabledTabs?.[t];
        const disabled = !!disabledReason;
        const button = (
            <TabButton
                key={t}
                selected={t === selected}
                $disabled={disabled}
                aria-disabled={disabled}
                onClick={() => {
                    if (t === selected || disabled) {
                        return;
                    }

                    onSelect?.(t);
                }}
            >
                {t}
            </TabButton>
        );
        if (!disabled) {
            return button;
        }

        return (
            <CloneTooltipWrapper key={t} label={disabledReason} allowedPlacements={['bottom-start']}>
                {button}
            </CloneTooltipWrapper>
        );
    });
    return <TabsContainer>{tabItems}</TabsContainer>;
}
